/**
 * Display summary text for a student alert
 */
(function(){
  angular.module('EdxClassroomReportModule')
    .directive('edxStudentAlertSummaryMessage', function() {
      return {
        restrict: 'E',
        scope: {
          /**
           * The alert to summarize, this should be a flattened alert which include student name
           */
          alert: '=edxAlert'
        },
        templateUrl: '/resources/components/report/classroom/at-a-glance/student-alert-summary-message.directive.html',
        controller: [StudentAlertSummaryMessageController],
        controllerAs: 'vm',
        bindToController: true
      };
    });

  function StudentAlertSummaryMessageController() {
    var vm = this;
    _onInit();

    // noinspection UnnecessaryReturnStatementJS
    return;

    function _onInit() {

    }

  }

})();